export default {"src":"/_next/static/media/infoIconNew_24.832a6c3c.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};